import { render } from "./Home.vue?vue&type=template&id=10d534c6&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=10d534c6&scoped=true&lang=css"

import exportComponent from "/Users/jaakkojakara/Documents/Aekosbot/apps/aekosweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d534c6"]])

export default __exports__